@if (hasText() && title().enabled) {
  <div
    class="flex-auto"
    [deltaContentClass]="false"
    [ngStyle]="title() | responsiveStyle"
    [content]="content()"
    [deltaContent]="content().name"
    [renderData]="config()?.data"
    [preFilterData]="config()?.preFilterData"
    [item]="config()?.data && config()?.data[0] ? config().data[0] : null"
  ></div>
}
